import { Component, Input, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'hs-app-gear-action',
  templateUrl: './app-gear-action.component.html',
  styleUrls: ['./app-gear-action.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppGearActionComponent {
  @Input() isDisabled = false
}
